import { session } from "services/storage/general";

export const eventsSessionStorage = {
	eventId: {
		get: () => Number(session.get("eventId")),
		set: value => session.set("eventId", value),
		remove: () => session.remove("eventId"),
	},
	eventTitleForEventToastMessage: {
		get: () => session.get("eventTitleForEventToastMessage"),
		set: value => session.set("eventTitleForEventToastMessage", value),
		remove: () => session.remove("eventTitleForEventToastMessage"),
	},
	canUpdateEventDuration: {
		get: () => JSON.parse(session.get("canUpdateEventDuration")),
		set: value => session.set("canUpdateEventDuration", value),
	},
	eventDataForAttendance: {
		get: () => JSON.parse(session.get("eventDataForAttendance")),
		set: value =>
			session.set("eventDataForAttendance", JSON.stringify(value)),
		remove: () => session.remove("eventDataForAttendance"),
	},
	isDraftEvent: {
		get: () => JSON.parse(session.get("isEventDraft")),
		set: value => session.set("isEventDraft", value),
	},
	isCancelledEvent: {
		get: () => JSON.parse(session.get("isCancelledDraft")),
		set: value => session.set("isCancelledDraft", value),
	},
	currentTabIdxEventList: {
		get: () => {
			const value = parseInt(session.get("currentTabIdxEventList"));
			return isNaN(value) ? null : value;
		},
		set: value => session.set("currentTabIdxEventList", value),
	},
	currentEventFormStep: {
		get: () => {
			const value = parseInt(session.get("currentEventFormStep"));
			return isNaN(value) ? null : value;
		},
		set: value => session.set("currentEventFormStep", value),
	},
};
